// LiveAlerts.jsx — Real-time alert feed
import React, { useEffect, useRef } from "react";
import SignalCard from "./SignalCard";

const API = process.env.REACT_APP_API_URL || "http://localhost:8000";

export default function LiveAlerts({ signals, loading, selectedId, onSelect, onExit, marketOpen }) {
  const topRef = useRef(null);

  // Scroll to top when a new signal arrives
  const prevCount = useRef(signals.length);
  useEffect(() => {
    if (signals.length > prevCount.current) {
      topRef.current?.scrollIntoView({ behavior: "smooth" });
    }
    prevCount.current = signals.length;
  }, [signals.length]);

  if (loading && signals.length === 0) {
    return (
      <div className="flex flex-col gap-2 animate-pulse">
        {[1, 2, 3].map((i) => (
          <div key={i} className="h-24 bg-gray-200/60 rounded-xl" />
        ))}
      </div>
    );
  }

  if (!loading && signals.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center py-16 text-gray-600 gap-2">
        <span className="text-4xl">📭</span>
        <p className="text-sm">No signals yet today</p>
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-3">
      <div ref={topRef} />
      {signals.map((sig) => (
        <SignalCard
          key={sig.id}
          signal={sig}
          selected={selectedId === sig.id}
          onClick={() => onSelect(sig)}
          onExit={onExit}
          marketOpen={marketOpen}
        />
      ))}
    </div>
  );
}

